import type {SlamPointCloudRepository} from '@/domain/interfaces/SlamPointCloudRepository';
import type {UavPointCloudRepository} from '@/domain/interfaces/UavPointCloudRepository';

export class DownloadPointCloudsUseCase {
  constructor(private readonly repository: UavPointCloudRepository | SlamPointCloudRepository) {}
  async execute(uuid: string) {
    const pointCloud = await this.repository.get(uuid);
    if (pointCloud) {
      const urls = await this.repository.getUrls(pointCloud.uuid);
      const a = document.createElement('a');
      a.href = urls.downloadUrl;
      a.download = `${pointCloud.uuid}.laz`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  }
}
